import Component from '@glimmer/component';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import { localCopy } from 'tracked-toolbox';

const TOOLTIP_TEXT = 'Global sign-in flow';

interface GlobalFlowIconSignature {
  Args: {
    /**
     * Whether or not to show the icon.
     * @defaultValue `true`
     */
    show?: boolean;
    /**
     * Text to display in a tooltip when mousing over the icon.
     * @defaultValue `"Global sign-in flow"`
     */
    tooltipText?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLSpanElement;
}

export default class GlobalFlowIcon extends Component<GlobalFlowIconSignature> {
  @localCopy('args.tooltipText', TOOLTIP_TEXT) declare tooltipText: string;
  @localCopy('args.show', true) declare show: boolean;

  <template>
    <span class="inline-flex items-center relative {{if this.show 'leading-4'}}" ...attributes>
      <span class="inline">{{yield}}</span>
      {{#if this.show}}
        <span class="global-flow-icon ml-1" data-test-global-flow-icon>
          <EmberTooltip @delay={{400}} @side="right">
            <span class="inline whitespace-nowrap">{{this.tooltipText}}</span>
          </EmberTooltip>
        </span>
      {{/if}}
    </span>
  </template>
}
